const isMobileDevice = () => {
	const mobileBreakpoint = 992;

	return window?.innerWidth < mobileBreakpoint;
};

export default isMobileDevice;
